import { render } from "./NavBar.vue?vue&type=template&id=46f337b0&scoped=true&lang=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-46f337b0"

export default script